import { Stack } from '@healthinal/ui';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { useGetPatientByIdSuspense } from '../../../api/generated/patient-controller/patient-controller.ts';
import { EditCaseManagementForm } from './components/EditCaseManagementForm.tsx';
import { EditPatientForm } from './components/EditPatientForm.tsx';
import { SelectPatientCard } from './components/SelectPatientCard.tsx';

export const Route = createFileRoute('/patients/$patientId/')({
  component: Patient,
  staticData: { title: 'Personalien' },
});

function Patient() {
  const { patientId } = Route.useParams();
  const { data: patient } = useGetPatientByIdSuspense(patientId);

  const [showEditForm, setShowEditForm] = useState(!!patient.personId);
  const [formVersion, setFormVersion] = useState(0);

  return (
    <Stack direction="row" gap={2}>
      <Stack flex={1} gap={2}>
        <SelectPatientCard
          patientId={patient.id}
          personId={patient.personId}
          caseNumber={patient.caseNumber as string}
          onPersonSelected={(person) => {
            setShowEditForm((person?.id ?? null) === (patient.personId ?? null));
          }}
          onCompleted={() => {
            setShowEditForm(true);
          }}
          onPersonSynced={() => {
            setFormVersion((prev) => prev + 1);
          }}
        />

        {showEditForm && (
          <EditPatientForm
            key={`${patient.id}-${formVersion}`}
            patient={patient}
            onPersonSynced={() => {
              setFormVersion((prev) => prev + 1);
            }}
          />
        )}
      </Stack>

      <Stack flex={1} gap={2}>
        <EditCaseManagementForm patient={patient} />
      </Stack>
    </Stack>
  );
}
